import React from 'react';
import SolutionDetail from '../components/SolutionDetail';
import TerrainIcon from '@mui/icons-material/Terrain';

const solutionData = {
  id: 'geophysical-survey',
  name: 'Geophysical Survey',
  icon: <TerrainIcon sx={{ fontSize: 60 }} />,
  description: 'Advanced geological mapping and mineral exploration',
  overview: `Our geophysical surveys map geology and geologic structure in mineral exploration and mineral prospecting. The technology has been proven on Fixed Wing, Helicopter and UAV platforms. It's specially designed for high resolution and noise-free data and it's based on a unique optically pumped Potassium sensor technology that offers an order of magnitude increase in sensitivity over other systems. Major applications include mapping of targeted geology and geologic structure in mineral exploration and prospecting, Perform frontier evaluation, augment seismic data in Hydrocarbon Exploration, Map pipelines and other cultural objects in Environmental and Engineering Investigations, Map aquifers and faults in Groundwater work etc.`,
  features: [
    {
      title: 'Multi-Platform Capability',
      description: 'Surveys via Fixed Wing, Helicopter, and UAV platforms',
    },
    {
      title: 'Advanced Sensor Technology',
      description: 'Optically pumped Potassium sensor for high sensitivity',
    },
    {
      title: 'Mineral Exploration',
      description: 'Targeted geology and structure mapping for prospecting',
    },
    {
      title: 'Hydrocarbon Exploration',
      description: 'Seismic data augmentation and frontier evaluation',
    },
    {
      title: 'Environmental Mapping',
      description: 'Pipeline mapping and groundwater fault detection',
    },
  ],
  benefits: [
    'High-resolution geological data',
    'Noise-free data acquisition',
    'Multiple platform flexibility',
    'Comprehensive exploration support',
    'Advanced sensor sensitivity',
  ],
};

const GeophysicalSurvey = () => {
  return <SolutionDetail solution={solutionData} />;
};

export default GeophysicalSurvey; 